var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.domainLike
    ? _c(
        "div",
        {
          staticClass: "vds-domain-check",
          attrs: {
            role: "status",
            "aria-live": "polite"
          }
        },
        [
          _vm.checking
            ? _c(
                "div",
                {
                  staticClass:
                    "text-caption d-flex align-center vds-domain-check__checking"
                },
                [
                  _c("v-progress-circular", {
                    staticClass: "mr-2",
                    attrs: {
                      indeterminate: "",
                      size: "13",
                      width: "2",
                      "aria-hidden": "true"
                    }
                  }),
                  _vm._v(" Checking DNS… ")
                ],
                1
              )
            : _vm.result
            ? [
                _vm.result.domain == null
                  ? _c(
                      "v-alert",
                      {
                        staticClass:
                          "mb-0 py-2 kvm-dc-alert kvm-dc-alert--warn",
                        attrs: {
                          type: "warning",
                          dense: "",
                          text: ""
                        }
                      },
                      [_vm._v(" That doesn't look like a valid domain. ")]
                    )
                  : _vm.result.matches
                  ? _c(
                      "v-alert",
                      {
                        staticClass: "mb-0 py-2 kvm-dc-alert kvm-dc-alert--ok",
                        attrs: {
                          type: "success",
                          dense: "",
                          text: ""
                        }
                      },
                      [
                        _c("strong", [_vm._v(_vm._s(_vm.result.domain))]),
                        _vm._v(
                          " points to your server (" +
                            _vm._s(_vm.result.target_ip) +
                            "). "
                        )
                      ]
                    )
                  : _c(
                      "v-alert",
                      {
                        staticClass:
                          "mb-0 py-2 kvm-dc-alert kvm-dc-alert--warn",
                        attrs: {
                          type: "warning",
                          dense: "",
                          text: ""
                        }
                      },
                      [
                        _c("strong", [_vm._v(_vm._s(_vm.result.domain))]),
                        _vm._v(" doesn't point to your server's IP ("),
                        _c("strong", [_vm._v(_vm._s(_vm.result.target_ip))]),
                        _vm._v(
                          ")" +
                            _vm._s(_vm.resolvedText) +
                            ". SSL (Let's Encrypt) won't be able to issue until its DNS points here — you can still deploy and fix DNS later. "
                        )
                      ]
                    )
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }